import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Users, FileText, Calendar, Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DashboardHome = () => {
  const [stats, setStats] = useState({
    members: 0,
    news: 0,
    events: 0,
    contacts: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      const [membersRes, newsRes, eventsRes, contactsRes] = await Promise.all([
        axios.get(`${API}/members`, config),
        axios.get(`${API}/news`),
        axios.get(`${API}/events`),
        axios.get(`${API}/contacts`, config)
      ]);

      setStats({
        members: membersRes.data.length,
        news: newsRes.data.length,
        events: eventsRes.data.length,
        contacts: contactsRes.data.length
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">Welcome to Admin Dashboard</h2>
        <p className="text-gray-600">Manage your association's content and members</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-12">
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl p-6 text-white shadow-xl" data-testid="stat-members">
            <div className="flex items-center justify-between mb-4">
              <Users size={32} />
              <span className="text-3xl font-bold">{stats.members}</span>
            </div>
            <h3 className="text-lg font-semibold">Total Members</h3>
          </div>

          <div className="bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl p-6 text-white shadow-xl" data-testid="stat-news">
            <div className="flex items-center justify-between mb-4">
              <FileText size={32} />
              <span className="text-3xl font-bold">{stats.news}</span>
            </div>
            <h3 className="text-lg font-semibold">News Articles</h3>
          </div>

          <div className="bg-gradient-to-br from-green-400 to-green-600 rounded-2xl p-6 text-white shadow-xl" data-testid="stat-events">
            <div className="flex items-center justify-between mb-4">
              <Calendar size={32} />
              <span className="text-3xl font-bold">{stats.events}</span>
            </div>
            <h3 className="text-lg font-semibold">Events</h3>
          </div>

          <div className="bg-gradient-to-br from-purple-400 to-purple-600 rounded-2xl p-6 text-white shadow-xl" data-testid="stat-contacts">
            <div className="flex items-center justify-between mb-4">
              <Mail size={32} />
              <span className="text-3xl font-bold">{stats.contacts}</span>
            </div>
            <h3 className="text-lg font-semibold">Contact Messages</h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardHome;